<template>
  <div class="customer-payment">
    <div class="customer-select" v-if="step === 1">
      <mu-form :model="form" class="form" label-width="100">
        <mu-form-item label="客户">
          <mu-auto-complete :data="allCustomer" :max-search-results="5" v-model="form.customerStr" open-on-focus
            :filter="customerFilter" @select="customerSelect">
            <template slot-scope="scope">
              <mu-list-item-content v-html="scope.highlight"></mu-list-item-content>
            </template>
          </mu-auto-complete>
        </mu-form-item>
        <mu-form-item>
          <mu-button color="primary" @click="next">下一步</mu-button>
        </mu-form-item>
      </mu-form>
    </div>
    <div class="finance" v-if="step === 2">
      <mu-button color="secondary" class="back-btn" @click="back">
        <mu-icon value="reply"></mu-icon>
        返回
      </mu-button>
      <mu-card class="customer-card">
        <mu-card-header :title="form.customer.company + ' - ' + form.customer.realName">
          <mu-button small color="primary" @click="handleAddPayment">
            <mu-icon value="add"></mu-icon>
            新增付款
          </mu-button>
        </mu-card-header>
        <div slot class="customer-card-content">
          <div class="list">
            <div class="item">
              <div class="title">当月欠款：</div>
              <div class="content">
                {{ month }}
              </div>
            </div>
            <div class="item">
              <div class="title">当年欠款：</div>
              <div class="content">
                {{ year }}
              </div>
            </div>
            <div class="item">
              <div class="title">总欠款：</div>
              <div class="content">
                {{ total }}
              </div>
            </div>
          </div>
          <div class="form-wrapper">
            <mu-form :model="form" class="form" label-width="100" inline>
              <mu-form-item prop="startTime" label="开始时间" label-float>
                <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
              </mu-form-item>
              <mu-form-item prop="endTime" label="结束时间" label-float>
                <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
              </mu-form-item>
              <mu-form-item label="操作">
                <mu-button color="primary" :loading="generatingLoading" @click="handleGenerateClick">
                  <mu-icon value="build"></mu-icon>
                  生成账单
                </mu-button>
              </mu-form-item>
            </mu-form>
          </div>
        </div>
      </mu-card>
      <mu-card class="payment-list-card">
        <mu-card-header title="付款历史"></mu-card-header>
        <mu-data-table solt :columns="columns" :data="paymentList" stripe class="table" :loading="loading">
          <template slot-scope="scope">
            <td>
              {{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm') }}
            </td>
            <td>{{ scope.row.money }}</td>
            <td>{{ scope.row.realMoney }}</td>
            <td>{{ scope.row.status }}</td>
            <td>{{ scope.row.remark }}</td>
            <td>
              <mu-button color="info" @click="detail(scope.row)" v-if="scope.row.status === '已审核通过'">
                <mu-icon left value="search" :size="20"></mu-icon>
                查看
              </mu-button>
            </td>
          </template>
        </mu-data-table>
      </mu-card>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()" :customer="form.customer" :total="total"></Create>
    <Details :open.sync="detailOpen" :list="detailList"></Details>
  </div>
</template>

<script>
import Create from './create'
import Details from './details'
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import * as XLSX from 'xlsx'
export default {
  components: { Create, Details },
  data() {
    return {
      moment,
      month: 0,
      year: 0,
      total: 0,
      step: 1,
      allCustomer: [],
      form: {
        customerStr: '',
        customer: {},
        startTime: moment().startOf('month').toDate(),
        endTime: moment().endOf('month').toDate()
      },
      isGenerated: false,
      orderList: [],
      generatingLoading: false,
      addOpen: false,
      detailOpen: false,
      detailList: [],
      paymentList: [],
      loading: false,
      columns: [
        {
          title: '日期',
          name: 'createTime',
          align: 'center'
        },
        {
          title: '记账金额',
          name: 'money',
          align: 'center'
        },
        {
          title: '付款金额',
          name: 'realMoney',
          align: 'center'
        },
        {
          title: '审核状态',
          name: 'status',
          align: 'center'
        },
        {
          title: '备注',
          name: 'remark',
          align: 'center'
        },
        {
          title: '抵扣详情',
          name: 'detail',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    handleGenerateClick() {
      this.generatingLoading = true
      backend(api.order.getOrdersByCustomerAndTime, {
        customerId: this.form.customer.id,
        startTime: this.form.startTime,
        endTime: this.form.endTime
      }).then((result) => {
        this.generatingLoading = false
        if (result.statusCode === 200) {
          this.orderList = result.data.rows
          this.isGenerated = true
          this.downloadExcel()
        }
      }).catch(() => {
        this.generatingLoading = false
      })
    },
    downloadExcel() {
      if (!this.orderList || this.orderList.length === 0) {
        this.$toast.error('没有订单数据')
        return
      }

      const customerName = this.form.customer.realName
      const startTimeStr = moment(this.form.startTime).format('YYYYMMDD')
      const endTimeStr = moment(this.form.endTime).format('YYYYMMDD')
      const fileName = `${customerName}-${startTimeStr}-${endTimeStr}订单.xlsx`

      const data = this.orderList.map((order) => ({
        '下单日期': moment(order.createTime).format('YYYY-MM-DD'),
        '订单号': order.orderId,
        '订单金额': parseFloat(order.sum),
        '已付金额': parseFloat(order.paid),
        '未付金额': parseFloat((parseFloat(order.sum) - parseFloat(order.paid)).toFixed(2))
      }))

      let totalSum = 0
      let totalPaid = 0
      let totalUnpaid = 0

      this.orderList.forEach((order) => {
        totalSum += parseFloat(order.sum)
        totalPaid += parseFloat(order.paid)
        totalUnpaid += parseFloat(order.sum) - parseFloat(order.paid)
      })

      data.push({
        '下单日期': '合计',
        '订单号': '',
        '订单金额': totalSum.toFixed(2),
        '已付金额': totalPaid.toFixed(2),
        '未付金额': totalUnpaid.toFixed(2)
      })

      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '订单')
      XLSX.writeFile(wb, fileName)
    },
    getAllCustomer() {
      backend(api.user.getAll, { getAll: true, isCustomer: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.allCustomer = result.data.rows
          }
        }
      )
    },
    customerFilter(text, data, maxSearchResults) {
      return data
        .filter(
          (x) => x.realName.indexOf(text) > -1 || x.company.indexOf(text) > -1
        )
        .map((item) => {
          const value = item.company + ' - ' + item.realName
          return {
            value,
            item,
            highlight: `<span>${value.replace(
              text,
              '<span class="mu-secondary-text-color">' + text + '</span>'
            )}</span>`
          }
        })
    },
    customerSelect(value, item) {
      this.form.customer = item
    },
    next() {
      if (this.form.customer.id === undefined) {
        this.$toast.error('请选择客户')
      } else {
        this.step++
        this.getCustomerData()
        this.getPaymentList()
      }
    },
    getCustomerData() {
      backend(api.payment.getCustomerData, {
        customerId: this.form.customer.id
      }).then((result) => {
        if (result.statusCode === 200) {
          let month = numeral(0)
          let year = numeral(0)
          let total = numeral(0)
          result.data.forEach((item) => {
            if (moment(item.createTime).isSame(moment(), 'month')) {
              month = month.add(item.sum).subtract(item.paid)
            }
            if (moment(item.createTime).isSame(moment(), 'year')) {
              year = year.add(item.sum).subtract(item.paid)
            }
            total = total.add(item.sum).subtract(item.paid)
          })
          this.month = month.value()
          this.year = year.value()
          this.total = total.value()
        }
      })
    },
    getPaymentList() {
      this.loading = true
      backend(api.payment.getAll, {
        getAll: true,
        customerId: this.form.customer.id,
        relations: ['payment.paymentDetails', 'paymentDetails.order']
      }).then((result) => {
        this.loading = false
        if (result.statusCode === 200) {
          this.paymentList = result.data.rows
        }
      })
    },
    detail(item) {
      this.detailList = item.paymentDetails
      this.detailOpen = true
    },
    back() {
      this.step--
      this.month = 0
      this.year = 0
      this.total = 0
      this.paymentList = []
    },
    handleAddPayment() {
      if (this.paymentList.some(x => x.status === '未审核')) {
        this.$toast.error('该客户有未审核的付款单，请先审核通过后再新增付款')
        return
      }
      this.addOpen = true
    }
  },
  mounted() {
    this.getAllCustomer()
  }
}
</script>

<style lang="less" scoped>
.customer-payment {
  .customer-select {
    display: flex;
    justify-content: center;
    align-items: center;

    .form {
      width: 360px;
    }
  }

  .finance {
    position: relative;

    .back-btn {
      position: absolute;
      right: 20px;
      top: 20px;
      z-index: 99;
    }

    .customer-card {
      .customer-card-content {
        padding-bottom: 20px;
        display: flex;
        justify-content: right;

        .list {
          flex: 1;

          .item {
            display: flex;

            .title {
              flex: 0 0 120px;
              text-align: right;
            }

            .content {
              flex: 1;
              margin-left: 10px;
            }
          }
        }

        .form-wrapper {
          flex: 0 0 816px;
          position: relative;

          .form {
            position: absolute;
            right: 0;
          }
        }
      }
    }

    .payment-list-card {
      margin-top: 20px;

      .table {

        th,
        td {
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payment/customer.vue